<template>
    <div class="nav">
        <div class="nav_item"><router-link to="/">Home</router-link></div>
        <div class="nav_item"><a href="javascript:;">Browse</a> <i class="iconfont icon-s-r"></i>
            <div class="browseList secondLevelList">
                <div @click="toBrowse(item)" class="browseItem secondLevelNavItem" v-for="(item, index) in browseList" :key="index">{{ item }}</div>
            </div>
        </div>
        <div class="nav_item"><a href="javascript:;">Interaction Network<i class="iconfont icon-s-r"></i></a>
            <div class="networkList secondLevelList">
                <router-link to="/network?type=network" class="networkItem secondLevelNavItem">Total Network</router-link>
                <router-link to="/network?type=BindingNetwork" class="networkItem secondLevelNavItem">Binding Network</router-link>
            </div>
        </div>
        <div class="nav_item"><router-link to="/statistics">Statistics</router-link></div>
        <div class="nav_item"><router-link to="/tools">Tools</router-link></div>
        <div class="nav_item"><router-link to="/download">Download</router-link></div>
        <div class="nav_item"><router-link to="/submit">Submit</router-link></div>
        <div class="nav_item"><router-link to="/help">Help</router-link></div>
    </div>
</template>

<script>
    export default {
        name: 'Nav',
        data() {
            return {
                browseList: ['Species', 'Diseases', 'Interactions', 'Structures', 'Peptide-coding', 'CircRNAs', 'Exosomal IncRNAs', 'Resistant IncRNAs'],
                networkValue: null,
            }
        },
        mounted() {
        },
        methods: {
            async toBrowse(item) {
                await this.$router.push(`/browse?type=${item}`)
            },
        }
    }
</script>

<style lang="less" scoped>
    .nav {
        width: 100%;
        padding: 0 60px;
        background-color: var(--theme-color);
        display: flex;
        justify-content: space-between;
        .nav_item {
            font-size: 26px;
            line-height: 60px;
            font-weight: 700;
            display: flex;
            align-items: center;
            position: relative;
            cursor: pointer;
            a {
                color: var(--lv2-color);
            }
            .iconfont {
                width: 40px;
                color: var(--lv2-color);
                display: inline-block;
                line-height: 48px;
                text-align: center;
                transition: all 0.3s ease 0s;
                &::before {
                    transform: rotate(90deg);
                    transform-origin: center;
                    display: inline-block;
                }
            }

            .secondLevelList {
                padding:20px 0;
                border-radius:5px;
                position: absolute;
                top: 100%;
                background-color: var(--theme-color);
                z-index: -1;
                opacity:0;
                pointer-events:none;
                box-shadow: 0 10px 10px rgba(0,0,0,.1);
                transform:translateY(-30px);
                transition: all 0.3s ease 0s;
                width: max-content;
                .secondLevelNavItem {
                    display: block;
                    color: var(--lv2-color);
                    padding: 5px 30px;
                    line-height: 30px;
                    font-size: 18px;
                    &:hover {
                        background-color: var(--lv2-color);
                        color: var(--theme-color);
                    }
                }
            }
            &:hover .iconfont {
                transform: rotate(180deg);
            }
            &:hover .secondLevelList {
                z-index:9999;
                opacity:1;
                pointer-events:all;
                transform:translateY(0);
            }
        }
    }
</style>